import { clearGeo } from '../../../packages/JsonQuery/clearGeo';
import { setRegionId } from '../../../packages/JsonQuery/setRegionId';
import { unsetUndergroundTravel } from '../../../packages/JsonQuery/unsetUndergroundTravel';
import { selectLocation } from 'shared/selectors/location';
import { TLocation } from 'shared/types/location';
import { TThunkAction } from 'shared/types/redux';
import { isNormalLocation, needClearGeo, needClearGeoLocation } from 'shared/utils/geo';
import { selectJsonQuery } from 'shared/selectors/jsonQuery';
import { setJsonQuery } from 'shared/slices/jsonQuery';
import { clearGeoLocation } from '../../../packages/JsonQuery/clearGeoLocation';

export const updateRegion =
  (nextLocation: TLocation): TThunkAction =>
  (dispatch, getState) => {
    const state = getState();
    const jsonQuery = selectJsonQuery(state);
    const currentLocation = selectLocation(state);

    let value: number[] = [];

    if (nextLocation === 'moscow_mo') {
      value = [1, 4593];
    } else if (nextLocation === 'spb_lo') {
      value = [2, 4588];
    } else if (nextLocation) {
      value = [nextLocation.id];
    }

    const actions = [setRegionId];

    if (needClearGeo(nextLocation, currentLocation)) {
      actions.push(clearGeo, unsetUndergroundTravel);
    } else if (
      isNormalLocation(currentLocation) &&
      needClearGeoLocation({ currentLocation, nextLocation, jsonQuery })
    ) {
      actions.push(clearGeoLocation(currentLocation.id));
    }

    const nextJsonQuery = actions.reduce((state, action) => action(state)(value), jsonQuery);

    dispatch(setJsonQuery(nextJsonQuery));
  };
